// extracted by mini-css-extract-plugin
export default {"tasksList":"TasksList_tasksList__5sTlR"};